import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-editor-block-host" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "gfu-editor-block-host__grip",
      draggable: "true",
      title: 'Drag to reorder · click for actions',
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.toggleMenu && $options.toggleMenu(...args)), ["prevent","stop"])),
      "data-qa": "editor-block-handle"
    }, [
      _createVNode(_component_base_icon, { name: "grip-vertical" })
    ]),
    ($data.menuOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "gfu-editor-block-host__menu",
          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
          "data-qa": "editor-block-menu"
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "gfu-editor-block-menu__item",
            onClick: _cache[1] || (_cache[1] = $event => ($options.act('move-up'))),
            "data-qa": "editor-block-menu:MoveUp"
          }, [
            _createVNode(_component_base_icon, {
              name: "arrow-up",
              class: "gfu-editor-block-menu__icon"
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Move up", -1 /* CACHED */))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "gfu-editor-block-menu__item",
            onClick: _cache[2] || (_cache[2] = $event => ($options.act('move-down'))),
            "data-qa": "editor-block-menu:MoveDown"
          }, [
            _createVNode(_component_base_icon, {
              name: "arrow-down",
              class: "gfu-editor-block-menu__icon"
            }),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Move down", -1 /* CACHED */))
          ]),
          ($props.canEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "gfu-editor-block-menu__item",
                onClick: _cache[3] || (_cache[3] = $event => ($options.act('edit'))),
                "data-qa": "editor-block-menu:Edit"
              }, [
                _createVNode(_component_base_icon, {
                  name: "pen-to-square",
                  class: "gfu-editor-block-menu__icon"
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "Edit", -1 /* CACHED */))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            type: "button",
            class: "gfu-editor-block-menu__item",
            onClick: _cache[4] || (_cache[4] = $event => ($options.act('add-below'))),
            "data-qa": "editor-block-menu:AddBelow"
          }, [
            _createVNode(_component_base_icon, {
              name: "plus",
              class: "gfu-editor-block-menu__icon"
            }),
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "Add below", -1 /* CACHED */))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "gfu-editor-block-menu__item gfu-editor-block-menu__item--danger",
            onClick: _cache[5] || (_cache[5] = $event => ($options.act('remove'))),
            "data-qa": "editor-block-menu:Remove"
          }, [
            _createVNode(_component_base_icon, {
              name: "trash",
              class: "gfu-editor-block-menu__icon"
            }),
            _cache[11] || (_cache[11] = _createElementVNode("span", null, "Delete", -1 /* CACHED */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}